import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { ServicosContent } from '@/features/servicos/shared/servicos-content';
import { DashboardServicos } from '@/features/servicos/shared/dashboard-servicos/dashboard-servicos';
import { ConsultaProtocoloServicos } from '@/features/servicos/shared/consulta-protocolo/consulta-protocolo-servicos';
import { SERVICOS_ROUTES } from '@/features/servicos/servicos.constants';
import { servicosVisualizarGuard } from '@/features/servicos/servicos-visualizar.guard';
import { servicosRelatorioRoutes } from '@/features/servicos/relatorios/servicos-relatorio.routes';

export const servicosRoutes: Routes = [
    {
        // Guard por :tipo (servicosVisualizarGuard): exige pessoa-fisica/pessoa-juridica.servicos.visualizar
        // conforme o :tipo da rota, redirecionando a /sem-acesso. O backend também barra os dados por role.
        path: `${SERVICOS_ROUTES.ROOT}/:tipo`,
        component: ServicosContent,
        canActivate: [servicosVisualizarGuard],
        data: { breadcrumb: 'Serviços' },
        children: [
            { path: '', component: DashboardServicos },
            { path: SERVICOS_ROUTES.PROTOCOLO, component: ConsultaProtocoloServicos, data: { breadcrumb: 'Consultar Protocolo' } },
            // Filhas de :tipo (não irmãs): herdam o servicosVisualizarGuard do pai, que já valida a
            // role conforme o :tipo — rota irmã exigiria inventar regra de permissão nova. O
            // Envelhecimento era filho direto daqui e passou a ser um dos relatórios, dentro deste
            // bloco: ele responde a mesma família de perguntas dos outros seis.
            ...servicosRelatorioRoutes,
            {
                path: `${SERVICOS_ROUTES.ITEM}/:codigo`,
                component: DashboardServicos,
                resolve: {
                    breadcrumb: (route: ActivatedRouteSnapshot) => route.fragment
                },
                data: { breadcrumb: null }
            }
        ]
    }
];

export default servicosRoutes;
